import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlagEnum } from 'src/app/domain/features-flags/enum/featureFlag.enum';
import { FeatureFlagPort } from 'src/app/domain/features-flags/port/feature-flag.port';
import { Auth } from 'src/app/domain/models/auth.model';



@Injectable({
  providedIn: 'root'
})
export class FeatureFlagUsecase implements FeatureFlagPort {
  constructor( private featureFlagService:FeatureFlagPort) { }

  configFeatureFlag(authData: Auth | any): Observable<void>  {
    return this.featureFlagService.configFeatureFlag(authData);
  }

  getFeatureFlag(id:FeatureFlagEnum): Observable<boolean> {
    return this.featureFlagService.getFeatureFlag(id);
  }
}
